import { CustomSection } from "./CustomSection";

export class CustomField {
    constructor(accountId,status,module,serviceProviderId)
    {
        this.id=null;
        this.fieldName=null;
        this.fieldType=null;
        this.fieldValue=null;
        this.accountId=accountId;
        this.status=status;
        this.module=module;
        this.isMandatory=false;
        this.regex=null;
        this.minLength=null;
        this.maxLength=null;
        this.fieldOrder=0;
        this.fieldOptions=null;
        this.created=null;
        this.lastUpdated=null;
        this.isSearchable=false;
        this.isConfidential=true;
        this.includeInReport=true;
        this.isUnique=false;
        this.sectionId=null;
        this.deviceType=null;
        this.fieldIdentity="NONE";
        this.parentFieldId=null;
        this.serviceProviderId=serviceProviderId;

    }
    id: string;
    accountId: number;
    fieldName: string;
    fieldType: string;
    fieldValue:string;
    isMandatory: boolean;
    regex: string;
    minLength: number;
    maxLength: number;
    fieldOrder: number;
    fieldOptions: any;
    status: boolean;
    created: string;
    lastUpdated: string;
    isSearchable: boolean;
    isConfidential:boolean;
    includeInReport:boolean;
    isUnique:boolean;
    sectionId:string;
    module: string;
    deviceType:string;
    fieldIdentity:string;
    parentFieldId:string;
    serviceProviderId:number;
}

